export const AuthKey = {
    access_token: 'dkjfhgieurty',
    refresh_token: '8473ueyw',
    expires: 'jdksla73910',
};
